module.exports = __webpack_public_path__ + "img/joystick.1cabfb70.svg";